function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 100 100",
  overflow: "visible"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#C4D600",
  strokeWidth: "12",
  strokeLinecap: "square",
  d: "M10 10l80 80M90 10L10 90"
})));